import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { auth } from '../Firebase';

// /magic?token=… — a magic link from an email (backend
// services/magicLoginToken.js): signs the member in without a password for
// 24 hours after it was sent, then takes them where the link says (e.g.
// their community bot chat). If the link has expired, or signing in here
// doesn't work, it asks them to log in as usual.
const MagicLogin = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [state, setState] = useState('signing-in'); // 'signing-in' | 'expired' | 'failed'

  useEffect(() => {
    const token = params.get('token');
    if (!token) { setState('expired'); return; }
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/magic-login`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token }),
        });
        const data = await res.json().catch(() => ({}));
        if (cancelled) return;
        if (!res.ok || !data.customToken) { setState(res.status === 400 ? 'expired' : 'failed'); return; }
        await auth.signInWithCustomToken(data.customToken);
        if (!cancelled) navigate(data.to || '/messenger', { replace: true });
      } catch (err) {
        console.error('[magic-login]', err);
        if (!cancelled) setState('failed');
      }
    })();
    return () => { cancelled = true; };
  }, [params, navigate]);

  return (
    <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem 1rem', textAlign: 'center' }}>
      {state === 'signing-in' ? (
        <div>
          <div className="spinner" style={{ margin: '0 auto 1rem' }} />
          <p style={{ fontSize: '1.1rem', color: '#334155' }}>Signing you in…</p>
        </div>
      ) : (
        <div style={{ maxWidth: '26rem' }}>
          <h2 style={{ marginBottom: '0.6rem' }}>{state === 'expired' ? 'This link has expired' : "We couldn't sign you in"}</h2>
          <p style={{ color: '#475569', marginBottom: '1.2rem' }}>
            {state === 'expired'
              ? 'Sign-in links in our emails work for 24 hours. Please log in to carry on.'
              : 'Please log in to carry on — it only takes a moment.'}
          </p>
          <Link to="/login" className="button">Log in</Link>
        </div>
      )}
    </div>
  );
};

export default MagicLogin;
